"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CallLogWarningMessage = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const styles_1 = require("../../styles");
const icons_1 = require("../icons");
const layout_1 = require("../layout");
const typography_1 = require("../typography");
const CallLogWarningMessage = ({ message }) => {
    return ((0, jsx_runtime_1.jsxs)(layout_1.Row, Object.assign({ mr: 5, backgroundColor: styles_1.Theme.colors.errorPink, borderRadius: "10px", padding: "10px 15px", justifyContent: "center", alignItems: "center" }, { children: [(0, jsx_runtime_1.jsx)(layout_1.Row, Object.assign({ flexShrink: 0, mr: 4 }, { children: (0, jsx_runtime_1.jsx)(icons_1.AppIcon, { name: 'AlertIcon', color: styles_1.Theme.colors.red60, size: "medium" }) })), (0, jsx_runtime_1.jsx)(typography_1.AppText, Object.assign({ color: "red60", style: {
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis',
                } }, { children: message }))] })));
};
exports.CallLogWarningMessage = CallLogWarningMessage;
//# sourceMappingURL=call_log_warning_message.js.map